<template>
    <div class="p-3 row">
        <input-date-time class="col-12 col-md-3" :disabled="readonly" label="Data do envio" v-model="form.data" ref="data" required type="date"/>
        <input-text class="col-12 col-md-3" :disabled="readonly" label="Versão XML" v-model="form.versao" ref="versao" required/>
        <div class="col-12 mb-2">
            <upload 
                :id="idUpload"
                tituloArquivo="Arrastar Arquivo" 
                selecioneArquivo="Selecionar Arquivo" 
                type=".*"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeArquivoAWS = nomeArquivo;
                    form.conteudoBase64 = file;
                }" />
        </div>   
        <div class="col-12" v-if="!readonly">
            <b-button variant="success" v-if="permissao.c" @click="$emit('salvar',form)">
                <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
                Upload comprovante
            </b-button>
        </div>     
        <div class="col-12 mt-3">
            <h6>Lista de comprovantes</h6>
            <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="$emit('download', data.item.nomeArquivo, data.item)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime';
import InputText from '@/components/inputs/InputText';
import Upload from '@/components/upload/Upload';

import helpers from '@/common/utils/helpers';
import {FormMixin} from '@/common/mixins/FormMixin';
export default {
    name: "AnnelComprovante",
    mixins: [FormMixin],
    components: {
        InputDateTime,
        Upload,
        InputText,
    },   
    props: {
        itens : {
            type: Array,
            default: () => []
        },
        idUpload: {
            type: String,
            require
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data: () => ({
        form : {
            arquivoObrigatorio : [
                {
                    nomeCampo : 'Comprovante',
                    campo : 'conteudoBase64',
                }
            ],
            data: null,
            nomeArquivoAWS: "",
            versao: 0,
            conteudoBase64: null
        },
        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão XML"},
                { key: "data", label:"Data de envio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        },
        options : {
            regra : helpers.getRegrasProjetos()
        }
    }),    
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    computed :{
        readonly :function(){
            return this.$route.name != 'projeto-gestao-proponente-detalhamento' || !this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoObrigacoesAneel');
        },
    }
}
</script>
<style lang="">
    
</style>